module.exports = __webpack_public_path__ + "static/assets/4609e0cfa99f227e84b3ab9961efa778.png";